import { Injectable } from '@angular/core';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { finalize } from 'rxjs/operators';
import { ApiService } from './api.service';

@Injectable()
export class SessionService {

  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    private apiService: ApiService
  ) { }

  start() {
    // timeout -- 4 + 1 mins
    this.idle.setIdle(4 * 60);
    this.idle.setTimeout(60);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    this.idle.onTimeout.subscribe(() => {
      alert('Your session has expired due to inactive response, please log in again.');
      this.logout();
    });
    this.keepalive.interval(30);
    this.idle.watch();
  }

  stop() {
    this.idle.ngOnDestroy();
    this.idle.onTimeout.observers.length = 0;
    this.idle.onIdleStart.observers.length = 0;
    this.idle.onIdleEnd.observers.length = 0;
  }

  logout() {
    this.apiService.logout().pipe(finalize(() => window.location.href = '/login')).subscribe();
    this.sniff('AUTO_LOGOUT', '');
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'HOME',
      target: target
    };
    this.apiService.sniff(data).subscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/services/session.service.ts